import React from 'react';
import styled from 'styled-components';
import Title from "../components/Title";
import {
    Card,
    Col,
    Empty,
    Row,
    Space,
    Spin,
    Typography,
} from "antd";
import SubBanner from "../components/SubBanner";
import ContentContainer from "../components/ContentContainer";
import Section from "../components/Section";
import {useParams} from "react-router-dom";
import SubTitle from "../components/SubTitle";
import CardRecentNews from "../components/CardRecentNews";
import Image from "../components/Image";
import DateNews from "../components/DateNews";
import CKEditorContent from "../components/CKEditorContent";
import {UserOutlined} from "@ant-design/icons";
import useDefaultRequest from "../hooks/useDefaultRequest";
import ENDPOINTS from "../constants/endpoints";
import {formatPath, ROUTES} from "../constants/PathRoutes";

const StyledSection = styled(Section)`
    padding-top: 24px;
    padding-bottom: 24px;
`

const StyledVideoDiv = styled.div`
    & * {
        max-width: 100%;
    }
`

export default function TransparencyDetail() {
    const {slug} = useParams()

    const {data: document, isLoading} = useDefaultRequest({
        url: formatPath(ENDPOINTS.TRANSPARENCY_DETAIL_PUBLIC, {slug}),
        dataDefault: {},
        redirectRoute: ROUTES.TRANSPARENCIA,
        dependence: [slug]
    })

    const {data: recentDocuments} = useDefaultRequest({
        url: ENDPOINTS.TRANSPARENCY_DETAIL_LATEST_PUBLIC,
        dataDefault: [],
        dependence: [slug]
    })

    return (
        <>
            <SubBanner title={'Transparência'}/>
            <StyledSection>
                <ContentContainer>
                    <Spin spinning={isLoading}>
                        <Row gutter={[24, 24]}>
                            <Col xs={24}>
                                <Card title={
                                    <Space direction={'vertical'} size={0}>
                                        <Title color={'black'} style={{whiteSpace: "wrap", marginBottom: 0}}>{document.title}</Title>
                                        <Typography.Text style={{fontSize: 18}} type={'secondary'}>{document.preview}</Typography.Text>
                                        <Space size={24}>
                                            <Space>
                                                <UserOutlined/>
                                                <span>{document?.author_fullname}</span>
                                            </Space>
                                            <DateNews value={document.created_at}/>
                                        </Space>
                                    </Space>
                                }>
                                    <Image src={document.image}/>
                                    <CKEditorContent content={document.content}/>
                                </Card>
                            </Col>

                            {document.video && (
                                <Col xs={24}>
                                    <StyledVideoDiv
                                        dangerouslySetInnerHTML={{__html: document.video}}
                                    />
                                </Col>
                            )}

                            <Col xs={24} style={{marginBottom: 0}}>
                                <SubTitle>Informações recentes</SubTitle>
                            </Col>

                            {recentDocuments.length > 0 ? (
                                recentDocuments.map(({image, created_at, title, slug, preview}) => (
                                    <Col xs={24} md={12} lg={6} key={slug}>
                                        <CardRecentNews
                                            slug={slug}
                                            date={created_at}
                                            title={title}
                                            image={image}
                                            resume={preview}
                                            baseRoute={ROUTES.TRANSPARENCIA}
                                        />
                                    </Col>
                                ))
                            ) : (
                                <Col xs={24}>
                                    <Empty description={'Sem documentos recentes'}/>
                                </Col>
                            )}
                        </Row>
                    </Spin>
                </ContentContainer>
            </StyledSection>
        </>
    )
}